import { API_STRING as api } from '@/App';

import { logger } from '@/utils/logger';
// Generate or retrieve session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('session_id');
  if (!sessionId) {
    sessionId = `session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('session_id', sessionId);
  }
  return sessionId;
};

// Track a click/view event
export const trackEvent = async (itemType, itemId, action, source = null) => {
  try {
    const sessionId = getSessionId();
    
    await fetch(`${api}/analytics/track`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        item_type: itemType,
        item_id: itemId,
        action: action,
        source: source,
        session_id: sessionId
      })
    });
  } catch (error) {
    // Silently fail - don't disrupt user experience
    logger.debug('Analytics tracking failed:', error);
  }
};

// Helper functions for common tracking scenarios
export const trackProductView = (productId, source = 'browse') => {
  trackEvent('product', productId, 'view', source);
};

export const trackProductClick = (productId, source = 'browse') => {
  trackEvent('product', productId, 'click_merchant', source);
};

export const trackCategoryView = (categoryName) => {
  trackEvent('category', categoryName, 'view', 'browse');
};

export const trackDeckView = (deckId, source = 'browse') => {
  trackEvent('deck', deckId, 'view', source);
};

export const trackFeaturedSectionView = (sectionId) => {
  trackEvent('featured_section', sectionId, 'view', 'browse');
};
